import { Sparkles } from 'lucide-react';

/**
 * Gradient pink-amber pill displayed next to an Ultimate subscriber's name.
 * Renders nothing if no tag is provided.
 */
export default function UltimateTag({ tag, size = 'sm', className = '' }) {
  if (!tag) return null;
  const padding = size === 'xs' ? 'px-1.5 py-[1px]' : 'px-2 py-0.5';
  const text = size === 'xs' ? 'text-[9px]' : 'text-[10px]';
  const iconSize = size === 'xs' ? 'w-2.5 h-2.5' : 'w-3 h-3';
  return (
    <span
      className={`inline-flex items-center gap-1 ${padding} ${text} font-bold uppercase tracking-wider rounded-full bg-gradient-to-r from-[#F472B6] via-[#F59E0B] to-[#FCD34D] text-[#2A0314] shadow-[0_0_12px_rgba(244,114,182,0.35)] ${className}`}
      data-testid="ultimate-tag"
    >
      <Sparkles className={iconSize} />
      {tag}
    </span>
  );
}
